// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";  // 👈 ADD THIS

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDE3Nph5Jprx6x2bHu3j_oxIg3InsnaVus",
  authDomain: "cognicare-4d301.firebaseapp.com",
  projectId: "cognicare-4d301",
  storageBucket: "cognicare-4d301.appspot.com",
  messagingSenderId: "1043867369648",
  appId: "1:1043867369648:web:aaade00d5cefb1009e3b75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth instance
export const auth = getAuth(app);

// Firestore instance 👇
export const db = getFirestore(app); // 👈 ADD THIS
